import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { PaginationResponse } from '@wilson/base';
import { ConfigOptions, ConfigService } from '@wilson/config';
import {
  CreateProductDTO,
  ProductDTO,
  ProductDTOPayload,
  ProductListItem,
  ProductsPageQuery,
  ProductType,
} from '@wilson/interfaces';
import { stringify } from 'qs';
import { catchError, Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ProductsGatewayService {
  private readonly httpClient = inject(HttpClient);
  private readonly config = inject<ConfigOptions>(ConfigService);

  protected readonly path = 'products';

  public getProducts(
    params: { type?: ProductType } = {},
  ): Observable<ProductDTO[]> {
    const queryParams = params.type
      ? new HttpParams().set('type', params.type)
      : undefined;

    return this.httpClient
      .get<ProductDTO[]>(`${this.config.host}/${this.path}`, {
        params: queryParams,
      })
      .pipe(
        catchError(() => {
          return of([]);
        }),
      );
  }

  public getProductsPage(
    query: ProductsPageQuery,
  ): Observable<PaginationResponse<ProductListItem>> {
    const params = stringify(query, { arrayFormat: 'comma' });

    return this.httpClient.get<PaginationResponse<ProductListItem>>(
      `${this.config.host}/v2/${this.path}?${params}`,
    );
  }

  public updateProduct(
    id: string,
    payload: Partial<ProductDTOPayload>,
  ): Observable<ProductDTO> {
    return this.httpClient.patch<ProductDTO>(
      `${this.config.host}/${this.path}/${id}`,
      payload,
    );
  }

  public createProduct(payload: CreateProductDTO): Observable<ProductDTO> {
    return this.httpClient.post<ProductDTO>(
      `${this.config.host}/${this.path}`,
      payload,
    );
  }
}
